import { LoginMethod } from '@main/types';

export const TWO_FACTOR_AUTH_LOGIN_METHODS = [
  LoginMethod.SWEDISH_MOBILE_BANKID_ANY_DEVICE,
  LoginMethod.SWEDISH_MOBILE_BANKID_ANY_DEVICE_TEST,
  LoginMethod.SWEDISH_MOBILE_BANKID_OTHER_DEVICE,
  LoginMethod.SWEDISH_MOBILE_BANKID_OTHER_DEVICE_TEST,
  LoginMethod.SWEDISH_MOBILE_BANKID_OTHER_DEVICE_MOCK,
  LoginMethod.SWEDISH_MOBILE_BANKID_SAME_DEVICE,
  LoginMethod.SWEDISH_MOBILE_BANKID_SAME_DEVICE_TEST,
  LoginMethod.SWEDISH_SECURITY_TOKEN,
  LoginMethod.SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION,
  LoginMethod.SWEDISH_MOBILE_BANKID_SAME_DEVICE_CLIENT_SIDE_AUTHENTICATION_MOCK,
  LoginMethod.SWEDISH_MOBILE_BANKID_SAME_OR_OTHER_DEVICE,
  LoginMethod.ESTONIAN_SMART_ID,
  LoginMethod.ESTONIAN_SMART_ID_USERNAME,
  LoginMethod.ESTONIAN_MOBILE_ID,
  LoginMethod.ESTONIAN_MOBILE_ID_USERNAME,
  LoginMethod.NORWEGIAN_BANKID_ON_MOBILE,
  LoginMethod.DANISH_MITID,
  LoginMethod.DANISH_NEMID,
  LoginMethod.DANISH_MITID_SAME_DEVICE,
  LoginMethod.EMAIL,
];
